import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { PaymentManagementService } from '../payment-management.service';
import { ModalPaymentRejectComponent } from '../modal-payment-reject/modal-payment-reject.component';
import THBText from 'thai-baht-text'
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import pdfMake from 'pdfmake/build/pdfmake';
import { WaterMark } from 'src/app/shared/water-mark';
import { OldChulaLogo_Base64 } from 'src/app/shared/old-chula-logo-base64';
import { PaymentService } from '../../payment/payment.service';
import { Signature } from 'src/app/shared/signature';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-payment-verify',
  templateUrl: './payment-verify.component.html',
  styleUrls: ['./payment-verify.component.scss']
})
export class PaymentVerifyComponent implements OnInit {

  transId;
  paymentId;
  body;
  paymentDetail;
  payment;
  bodyConfirm;
  isLoading: boolean;
  evidence = [];
  evidenceImage = [];
  evidenceFile = [];

  statusPayment: any;
  remarkPriceForm: FormGroup;

  transferDateForm: FormGroup;
  isEditDate: boolean = false;
  today: Date;

  receiptDetail: any;
  isPrint: boolean = false;
  accountId: string = '';

  constructor(
    private fb: FormBuilder,
    private paymentManagementService: PaymentManagementService,
    private gobalFunctionService: GobalFunctionService,
    public matDialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private paymentService: PaymentService,
    private bsDatepickerConfig: BsDatepickerConfig,
  ) {
    this.bsDatepickerConfig.dateInputFormat = 'DD-MM-YYYY';
    this.today = new Date();
  }

  ngOnInit(): void {
    this.deleteQueryParameterFromCurrentRoute();
    this.isLoading = false;
    this.gobalFunctionService.setTitle('ตรวจสอบรายการทางการเงิน');

    this.paymentId = new URL(location.href).searchParams.get('paymentId');
    this.transId = new URL(location.href).searchParams.get('transId');
    this.accountId = new URL(location.href).searchParams.get('ACCOUNTING_ID');
    this.getDetailConfirmSlip();

    this.remarkPriceForm = this.fb.group({
      price: ['', Validators.required]
    })

  }

  getDetailConfirmSlip() {
    this.body = {
      TRANS_ID: this.transId,
      PAYMENT_ID: this.paymentId
    }

    this.paymentManagementService.getDetailConfirmSlip(this.body).pipe(
      map(res => {
        this.payment = res.result;
        this.paymentDetail = res.result[0].Detail;
        this.gettransferForm();
        let type;

        this.evidence = this.paymentDetail[0].EVIDENCE_DATA.map(el => {
          const fileType = el.EVIDEN_ORGINAL_NAME.split('.').pop();
          if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv') {
            type = 'file';
          } else {
            type = 'image';
          }
          return {
            ID: el.ID,
            EVIDEN_FILE: el.EVIDEN_FILE,
            EVIDEN_ORGINAL_NAME: el.EVIDEN_ORGINAL_NAME,
            CREATE_DATE: el.CREATE_DATE,
            TRANS_ID: el.TRANS_ID,
            TYPE_FILE: type,
          }
        })

        this.evidenceFile = this.evidence.filter((el) => el.TYPE_FILE === 'file');
        this.evidenceImage = this.evidence.filter((el) => el.TYPE_FILE === 'image');

      })
    ).subscribe();
  }

  gettransferForm() {
    this.transferDateForm = this.fb.group({
      PAYMENT_ID: [this.paymentId, Validators.required],
      TRANS_ID: [this.transId, Validators.required],
      TRANFER_DATE: [new Date(this.paymentDetail[0].TRANFER_DATE), Validators.required],
      TRANFER_HR: [this.paymentDetail[0].TRANFER_HR, Validators.required],
      TRANFER_MIN: [this.paymentDetail[0].TRANFER_MIN, Validators.required]
    })

    this.transferDateForm.disable();
    this.isEditDate = false;
  }

  editDate() {
    this.isEditDate = true;
    this.transferDateForm.enable();
  }

  cancelEdit() {
    this.isEditDate = false;
    this.transferDateForm.disable();
  }

  confirmEdit(value) {
    console.log(value)
    let body = {
      PAYMENT_ID: value.PAYMENT_ID,
      TRANS_ID: value.TRANS_ID,
      TRANFER_DATE: value.TRANFER_DATE,
      TRANFER_HR: value.TRANFER_HR.toString(),
      TRANFER_MIN: value.TRANFER_MIN.toString(),
    }
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'ยืนยันการตรวจสอบสถานะ',
      description: `<p class="text-center">ต้องการเปลี่ยนเวลาและวันที่ใช่หรือไม่?</p>`,
      actionBtnText: 'ตกลง',
      cancleBtnText: 'ย้อนกลับ',
    }
    const confirmDialog = this.matDialog.open(ModalComponent, dialogConfig);
    confirmDialog.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.paymentManagementService.updatePaymentByTransId(body).pipe(
            switchMap(res2 => {
              const dialogConfig2 = new MatDialogConfig();
              dialogConfig2.disableClose = true;
              dialogConfig2.id = 'modalConfirm';
              dialogConfig2.width = '350px';
              dialogConfig2.data = {
                title: 'ยืนยันการตรวจสอบสถานะ',
                description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                                <p class="title text-center">เปลี่ยนสำเร็จ</p>`,
                cancleBtnText: 'ยืนยัน',
                customStyle: 'background-color: #58595B'
              }
              const confirmModal = this.matDialog.open(ModalComponent, dialogConfig2);
              return confirmModal.afterClosed().pipe(
                map(res3 => {
                  this.getDetailConfirmSlip();
                  this.cancelEdit();
                })
              )
            })
          )
        } else {
          return of(null);
        }
      })
    ).subscribe();
  }

  time(e, t) {
    switch (t) {
      case 'hr': {
        if (e.target.value > 23) {
          this.transferDateForm.controls['TRANFER_HR'].setValue(23);
        }
        break;
      }
      case 'min': {
        if (e.target.value > 59) {
          this.transferDateForm.controls['TRANFER_MIN'].setValue(59);
        }
        break;
      }
    }
  }

  confirm(form) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'ยืนยันการตรวจสอบสถานะ',
      description: `<p class="text-center">ยืนยันหลักฐานการโอนถูกต้องและครบถ้วน?</p>`,
      actionBtnText: 'ตกลง',
      cancleBtnText: 'ย้อนกลับ',
      isConfirm: true
    }

    const formDialog = this.matDialog.open(ModalComponent, dialogConfig);
    this.isLoading = true;
    this.bodyConfirm = {
      STATUS: "success",
      TRANS_ID: this.transId,
      REMARK: "",
      REMARK_PRICE: form.price
    }

    formDialog.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.paymentManagementService.confirmPayment(this.bodyConfirm).pipe(
            switchMap(res => {
              this.isLoading = false;
              dialogConfig.disableClose = true;
              dialogConfig.id = 'modalConfirm';
              dialogConfig.width = '350px';
              dialogConfig.data = {
                title: 'ยืนยันการตรวจสอบสถานะ',
                description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                                <p class="title text-center">ตรวจสอบสำเร็จ</p>`,
                cancleBtnText: 'ยืนยัน',
                customStyle: 'background-color: #58595B'
              }
              const modal = this.matDialog.open(ModalComponent, dialogConfig);
              return modal.afterClosed().pipe(
                switchMap(res => {
                  // console.log(res);

                  return this.paymentService.getStatusPaymentById(this.paymentId).pipe(
                    map(res => {
                      // console.log(res);
                      this.isLoading = true;
                      this.statusPayment = res.result[0];
                      this.createReceipt();
                    })
                  )
                 
                })
              )
            })
          )
        } else {
          this.isLoading = false;
          return of(null)
        }
      })
    ).subscribe();
  }

  reject(form) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'ยืนยันการตรวจสอบสถานะ',
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ย้อนกลับ',
      isEdit: true,
    }

    const modal = this.matDialog.open(ModalPaymentRejectComponent, dialogConfig);
    this.isLoading = true;
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res.status) {
          // console.log(res.status);

          this.bodyConfirm = {
            STATUS: "reject",
            TRANS_ID: this.transId,
            REMARK: res.value,
            REMARK_PRICE: form.price,
          }

          const dialogConfig2 = new MatDialogConfig();
          return this.paymentManagementService.confirmPayment(this.bodyConfirm).pipe(
            switchMap(result => {
              if (result.success) {
                // console.log(result);
                this.isLoading = false;
                dialogConfig2.disableClose = true;
                dialogConfig2.id = 'modalConfirm';
                dialogConfig2.width = '350px';
                dialogConfig2.data = {
                  title: 'ยืนยันการตรวจสอบสถานะ',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                                  <p class="title text-center">ตรวจสอบสำเร็จ</p>`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B'
                }
                const confirmModal = this.matDialog.open(ModalComponent, dialogConfig2);
                return confirmModal.afterClosed().pipe(
                  map(r => {
                    // // console.log(r);
                    this.router.navigate(['/payment-management/payment-management-goverment'],
                      { queryParams: { ACCOUNTING_ID: this.accountId } });
                  })
                )
              } else {
                this.isLoading = false;
                return of(null);
              }
            })
          )
        }
        else {
          this.isLoading = false;
          // console.log(typeof (res.status));
          return of(null);
        }
      }),
      catchError(() => {
        return of(null);
      })
    ).subscribe();
  }

  deleteQueryParameterFromCurrentRoute() {
    this.router.navigate(
      ['.'],
      { relativeTo: this.route, queryParams: { id: this.paymentId, sd: this.transId } }
    );
  }

  download(file) {
    window.open(file, "_blank");
  }

  updatePayment

  createReceipt() {
    let receipt;
    let today = new Date();

    this.paymentManagementService.getSignature().pipe(
      map(res => {
        // // console.log(res);
        if (res.success) {

          receipt = {
            address: '',
            thbath: this.statusPayment.PRICE > 0 ? THBText(this.statusPayment.PRICE) : 'ฟรี',
            discount: this.statusPayment.PRICE === this.statusPayment.STANDARTPRICE ? 0 : this.statusPayment.STANDARTPRICE - this.statusPayment.SPECIALPRICE,
            price: this.statusPayment.REMARK_PRICE ? this.statusPayment.REMARK_PRICE : this.statusPayment.PRICE,
            standardPrice: this.statusPayment.STANDARTPRICE,
            specialPrice: this.statusPayment.SPECIALPRICE,
            type: this.statusPayment.Detail[this.statusPayment.Detail.length - 1].PAYMENT_TYPE === 'transfer' ? 'โอนเงิน' : '',
            paymentID: this.statusPayment.PAYMENT_ID,
            signaturePic1: Signature[0].signature,
            signatureName1: Signature[0].signatureName,
            signatureJobTitle1: Signature[0].position,
            signaturePic2: Signature[1].signature,
            signatureName2: Signature[1].signatureName,
            signatureJobTitle2: Signature[1].position,
            userName: this.statusPayment.NAME,
            userAddress: this.statusPayment.ADDRESS,
            taxID: this.statusPayment.TAX_NO,
            userPhone: this.statusPayment.PAYMENT_PHONENUMBER,
            date: new DatePipe().transform(this.statusPayment.UPDATE_DATE.toString(), 'full'),
            bankDate: today,
            printDate: `${new DatePipe().transform(today.toString(), 'full')} - ${today.getHours() > 9 ? '' : 0}${today.getHours()}:${today.getMinutes() > 9 ? '' : 0}${today.getMinutes()} น.`,
            paymentName: this.statusPayment.PAYMENT_NAME,
            receiptId: this.statusPayment.RECEIPT_ID,
            cardNo: this.statusPayment.CARD_NO,
          }

          this.receiptDetail = receipt;
          this.isPrint = true;
          setTimeout(() => {
            this.isPrint = false;
          }, 1000);

        }
      }),
      catchError((err) => {
        alert(err);
        return of(null);
      })
    ).subscribe();


  }

  sendMail(e) {
    let body = {
      PAYMENT_ID: this.paymentId,
      TRANS_ID: this.statusPayment.Detail[this.statusPayment.Detail.length - 1].TRANS_ID,
      TYPE: 'TRANSFER',
      base64str: e,
    };

    this.paymentService.saveBase64ReceiveBillSndMail(body).subscribe((res) => {
      // console.log(res);
      this.isLoading = false;
      this.router.navigate(['/payment-management/payment-management-goverment'],
        { queryParams: { ACCOUNTING_ID: this.accountId } });
    });
  }
}
